// extracted by mini-css-extract-plugin
export var dataCell = "_mn-2";
export var dataRow = "_mn-0";
export var headerRow = "_mn-1";